import { createAction } from '@reduxjs/toolkit';
import { Category } from '../../api';

export const loadCategoriesRequested = createAction<
  { saveLastState: boolean },
  'al/category/loadCategoriesRequested'
>('al/category/loadCategoriesRequested');

export const categoriesChanged = createAction<
  { categories: Category[] },
  'al/category/categoriesChanged'
>('al/category/categoriesChanged');

export const categorySelected = createAction<
  { id: Category['id']; saveLastState: boolean; log: { category: Category | null } },
  'al/category/categorySelected'
>('al/category/categorySelected');

export const setExpandedKeys = createAction<
  { keys: Category['id'][]; saveLastState: boolean },
  'al/category/setExpandedKeys'
>('al/category/setExpandedKeys');

export const setLoading = createAction<{ loading: boolean }, 'al/category/setLoading'>(
  'al/category/setLoading',
);
